import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngToJpegConfig } from '@/data/landingConfig/landingPngToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngToJpeg } from './schemaObject';

interface Props {}
const PngToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngToJpeg} />
			<LandingTemplate
				data={landingPngToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default PngToJpegConverter;
